import React from "react";
import SvgIcon from "@material-ui/core/SvgIcon";


export default function DownloadFileIcon(props: any) {
  const { style, viewBox, ...otherProps } = props;
  return (
    <SvgIcon
      {...otherProps}
      style={style || { width: 24, height: 24 }}
      viewBox={viewBox || "0 0 24 24"}
    >
      <path d="M5.55897 6.15357L13.7291 5.00325C13.7752 4.99673 13.8222 5.00005 13.8669 5.013C13.9115 5.02596 13.9529 5.04823 13.9881 5.07831C14.0233 5.1084 13.9478 5.013 14.0709 5.18737C14.1002 5.27114 14.1002 5.54564 14.1002 5.59157V18.6796C14.1002 18.7255 14.0902 18.7708 14.0709 18.8125C14.0516 18.8543 14.0234 18.8914 13.9883 18.9215C13.9532 18.9516 13.9119 18.9739 13.8673 18.9869C13.8227 18.9999 13.7758 19.0033 13.7297 18.9968L5.55832 17.8465C5.40338 17.8248 5.26161 17.7486 5.15904 17.6321C5.05647 17.5155 5 17.3664 5 17.2121V6.94155C5 6.78724 5.00063 6.55284 5.15904 6.36803C5.32562 6.23242 5.40403 6.17533 5.55897 6.15357ZM6.30058 7.34427V16.6558L12.8003 17.5716V6.4285L6.30058 7.34427ZM14.7502 16.486H16.7001V7.5141H14.7502V6.2324H17.35C17.5224 6.2324 17.6877 6.29991 17.8096 6.4201C17.9315 6.54028 18 6.70328 18 6.87325V17.1268C18 17.2968 17.9315 17.4598 17.8096 17.58C17.6877 17.7002 17.5224 17.7677 17.35 17.7677H14.7502V16.486ZM10.3304 12L12.1503 14.5634H10.5904L9.55042 13.0985L8.51047 14.5634H6.95055L8.77046 12L6.95055 9.43665H8.51047L9.55042 10.9016L10.5904 9.43665H12.1503L10.3304 12Z"
        fill="#36CE91"
      />
    </SvgIcon>
  );
};
